// import helper from '@/_libs/helper';

import auth from './_auth';

import customer from './_customer';
import history from './_history';
import user from './_user';
import product from './_product';
import order from './_order';
import notification from './_notification';
import billing from './_billing';

import cs from './cs';
import admin from './admin';

const api = {
  auth,

  customer,
  history,
  user,
  product,
  order,
  notification,
  billing,

  cs,
  admin,
};

export default {
  // ...helper,
  ...api,
  basePath: process.env.VUE_APP_API_ROOT,
};
